export const REGISTER_VEHICLE = `/tag/register`;
export const REGISTER_VEHICLE_NEW = `/tag/register/new`;
export const REGISTER_VEHICLE_SUMMARY = `/tag/register/new/summary`;